import './timeseries_chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TweetsPerMinuteView extends Monitoring.Views.Charts.TimeseriesChartView
  valueField: 'count'
  chartOptions:
    yAxis:
      min: 0
    legend:
      enabled: true

  initialize: (@options = {})->
    @title = I18n.t('monitoring.dashboard.charts.ugc')
    @title_en = I18n.t('monitoring.dashboard.charts.ugc', {'locale': 'en'})
    @series_counter = 1
    @benchmarks_active = []
    super
    @name = 'tweets_per_minute_view'

  addSeries: ->
    if @_dataIsEmpty()
      @$el.removeClass('processing')
    else
      query = @searchQuery.deepCopy()
      query.set('interval', @intervalParam)
      @ajaxCall("/monitoring/dashboard/charts/tpm/", query.toJSON(), (response) =>
        @date_from_realtime = response.date_from_realtime if response.date_from_realtime
        @date_to_realtime = response.date_to_realtime if response.date_to_realtime
        @addSerie('UGC', response.values, 1)
      )

    return this

  benchmarkOneDay: ->
    @_addBenchmarkSeries(1, '#f1cc0f')

  benchmarkOneWeek: ->
    @_addBenchmarkSeries(7, '#4572a7')

  benchmarkOneMonth: ->
    @_addBenchmarkSeries(30, '#80699b')

  _addBenchmarkSeries: (days, color = "#1c10f2") ->
    unless days in @benchmarks_active
      @_addBenchmarkSerie(days, color) 

  _addBenchmarkSerie: (days, color = "#1c10f2") ->
    @benchmarks_active.push(days)
    date_shifter = new Monitoring.Views.Charts.QueryDateShifter(@searchQuery.deepCopy())
    query = date_shifter.shiftXDaysBack(days)
    query.set('interval', @intervalParam)
    @series_counter += 1
    @ajaxCall("/monitoring/dashboard/charts/tpm/", query.toJSON(), (response) =>
      name = @_benchmarkName(days)
      @addSerie(name , @_shiftDataDate(response.values, days), @series_counter, color)
    )

  _benchmarkName: (days) ->
    names = {1: 'one_day_ago', 7:'seven_days_ago', 30: 'thirty_days_ago' }
    I18n.t('monitoring.dashboard.charts.one_day_ago')
    'UGC ' + I18n.t('monitoring.dashboard.charts.' + names[days])

  _shiftDataDate: (data, days) ->
    _.each(data, (value) ->
      value['date_to_show'] = value.time
      date = new Date (value.time)
      date.setDate(date.getDate() + days)
      value.time = date.getTime()
    )
    data

  getTimeSeries: (values, initialTime, finalTime) ->
    if values[0] && values[0].date_to_show
      step = @interval * 60000
      last = initialTime - step
      series = []
      _.each(values, (value) =>
        initialZeros = Math.floor((value.time - last) / step) - 1
        if initialZeros >= 1
          for x in [initialZeros..1]
            series.push({y: 0, show_date: values[0].date_to_show - x * step})
        last = value.time
        series.push({y: value['count'], show_date: value['date_to_show']})
      )
      finalZeros = Math.floor((finalTime - last) / step)
      if finalZeros >= 1
        for x in [1..finalZeros]
          if @accumulated
            series.push({y: _.last(values).count, show_date: _.last(values).date_to_show + x * step})
          else
            series.push({y: 0, show_date: _.last(values).date_to_show + x * step})
      series
    else
      super(values, initialTime, finalTime)

  addExtraMenuItems: =>
    extraItems = []
    if @isBenchmarkPossible(1)
      extraItems = extraItems.concat({
        id: 'benchmark-1'
        text: I18n.t('monitoring.dashboard.charts.one_day_ago')
      })
    if @isBenchmarkPossible(7)
      extraItems = extraItems.concat({
        id: 'benchmark-7'
        text: I18n.t('monitoring.dashboard.charts.seven_days_ago')
      })
    if @isBenchmarkPossible(30)
      extraItems = extraItems.concat({
        id: 'benchmark-30'
        text: I18n.t('monitoring.dashboard.charts.thirty_days_ago')
      })
    if @benchmarks_active.length > 0
      unless extraItems.length == 0 
        extraItems = extraItems.concat({
          separator:true
        })
      extraItems = extraItems.concat({
        id: 'benchmark-clear'
        text: I18n.t('monitoring.dashboard.charts.clear_benchmarks')
      })
    if not _.isEmpty(extraItems)
      $benchmarkAction = @$el.find('#benchmark-action')
      $benchmarkAction.html(@benchmarkActionTemplate({items: extraItems}))
      $benchmarkAction.find('#benchmark-1').on('click', () => @benchmarkOneDay())
      $benchmarkAction.find('#benchmark-7').on('click', () => @benchmarkOneWeek())
      $benchmarkAction.find('#benchmark-30').on('click', () => @benchmarkOneMonth())
      $benchmarkAction.find('#benchmark-clear').on('click', () => @clearBenchmarks())


  isBenchmarkPossible: (days) ->
    possible = !(@benchmarks_active.indexOf(days) > -1)
    possible &= @periodAllowsBenchmark(days)
    possible

  periodAllowsBenchmark: (days) ->
    date_shifter = new Monitoring.Views.Charts.QueryDateShifter(@searchQuery.deepCopy())
    actual_query = date_shifter.normalQuery()
    benchmark_query = date_shifter.shiftXDaysBack(days)
    actual_date_from = new Date(actual_query.toJSON().date_from_ISO)
    benchmark_date_to = new Date(benchmark_query.toJSON().date_to_ISO)
    actual_date_from > benchmark_date_to

  clearBenchmarks: ->
    for benchmark in @benchmarks_active
      @removeSerie(@singularSeries, @_benchmarkName(benchmark))
      @removeSerie(@accumulatedSeries, @_benchmarkName(benchmark))
    @series_counter = 1
    @benchmarks_active = []
    @_settings.zoom = undefined
    @renderChart()
    @trigger('masonry')


  _dataIsEmpty: ->
    @_totalContents() == 0

  _totalContents: ->
    @facets['date'].count

  titleWithExtra: ->
    @title + ' (' + @_withThousandsSeparator(@_totalContents()) + ')'

  _withThousandsSeparator: (numberAsString) ->
    parseInt(numberAsString).toLocaleString()